class OrganizationAccess {
    normalizeOrganizationId = (organizationId) => {
        if (organizationId === null || organizationId === undefined) {
            return "";
        }

        return String(organizationId).toLowerCase();
    };

    // The URL org segment is not always the id access is keyed by, so match leniently.
    findByOrganizationId = (organizationsAccess = {}, candidates = []) => {
        const keys = Object.keys(organizationsAccess);

        for (const candidate of candidates) {
            const normalized = this.normalizeOrganizationId(candidate).trim();

            if (!normalized) continue;

            const matchedKey = keys.find(
                (key) => this.normalizeOrganizationId(key).trim() === normalized
            );

            if (matchedKey) return organizationsAccess[matchedKey];
        }

        return undefined;
    };

    _format = (data) => {
        return {
            ORGANIZATIONID: this.normalizeOrganizationId(data?.OrganizationId),
            SSNACCESS: data.SSN,
            HISTORICALLEAVEACCESS: data.HistoricalLeave,
            SelfInsuredDisabilityClaimAccess: data.SelfInsuredClaim,
        };
    };

    format = (data) => {
        const list = [];

        for (let i = 0; i < data.length; i++) {
            list.push(this._format(data[i]));
        }

        return list;
    };
}

export default new OrganizationAccess();
